function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import cx from 'classnames';
import { Illustration } from '../Illustration';

var Third = function Third(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'default' : _ref$type,
      icon = _ref.icon,
      _ref$middle = _ref.middle,
      middle = _ref$middle === void 0 ? false : _ref$middle,
      _ref$center = _ref.center,
      center = _ref$center === void 0 ? false : _ref$center,
      _ref$right = _ref.right,
      right = _ref$right === void 0 ? false : _ref$right,
      _ref$photo = _ref.photo,
      photo = _ref$photo === void 0 ? false : _ref$photo,
      _ref$photoSize = _ref.photoSize,
      photoSize = _ref$photoSize === void 0 ? null : _ref$photoSize,
      children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, ["type", "icon", "middle", "center", "right", "photo", "photoSize", "children"]);

  var Icon = function Icon() {
    if (!icon) return /*#__PURE__*/React.createElement(React.Fragment, null);
    var Tag = icon;
    return /*#__PURE__*/React.createElement("div", {
      className: "icon"
    }, /*#__PURE__*/React.createElement(Tag, null));
  };

  var thirdClasses = cx('third', type && "type-" + type, middle && 'middle', right && 'right', photo && 'has-photo', photoSize && "photo-size-" + photoSize, icon && 'has-icon');
  var contentClasses = cx('content', center && 'center');
  return /*#__PURE__*/React.createElement("div", _extends({
    className: thirdClasses
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: contentClasses
  }, photo && /*#__PURE__*/React.createElement(Illustration, {
    src: photo
  }), /*#__PURE__*/React.createElement(Icon, null), children));
};

Third.displayName = 'Third';
var ThirdDoc;

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  ThirdDoc = require('./doc').doc(Third);
}

var ThirdWrapper = ThirdDoc || Third;
export { ThirdWrapper as Third };